import type { NodeId } from 'web';
import type { FlowGraph } from '../FlowGraph';

export class NumberSelectorView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  setSelected(selected: number, ongoing: boolean) {
    this.graph.wasmEdit((wasm) => {
      return wasm.setSelected(this.nodeId, selected);
    }, ongoing);
    this.graph.updateNodeOutputs(this.nodeId, ongoing);
  }
}
